/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
import { logger } from "../../utils/logger";
logger.deprecated("component", {
    name: "tip-group",
    removalVersion: 4,
    suggested: ["carousel", "carousel-item"],
});
/**
 * @deprecated Use the `calcite-carousel` and `calcite-carousel-item` components instead.
 * @slot - A slot for adding `calcite-tip`s.
 */
export class TipGroup {
    constructor() {
        this.groupTitle = undefined;
    }
    render() {
        return h("slot", { key: '40d9094358a1ef9165e9261d9ca351b2530a7584' });
    }
    static get is() { return "calcite-tip-group"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tip-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tip-group.css"]
        };
    }
    static get properties() {
        return {
            "groupTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component header text for all nested `calcite-tip`s."
                },
                "attribute": "group-title",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=tip-group.js.map
